import * as React from 'react';
import { parseQueryParams, removeQueryParams, stringifyQuery } from '@/utils/queryParams';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { isUserLoggedIn } from '@/redux/modules/user';
import { openSignUpModal } from '@/redux/modules/modal';

type QueryParams = {
    action?: string;
};

const SignupAction = () => {
    const isLoggedIn = useSelector(isUserLoggedIn);
    const location = useLocation();
    const history = useHistory();
    const queryParams = parseQueryParams<QueryParams>(location.search);
    const dispatch = useDispatch();
    React.useEffect(() => {
        if (queryParams.action === 'signup') {
            const query = removeQueryParams(queryParams, ['action']);
            const stringified = stringifyQuery(query);
            const newLocation = location.pathname + stringified ? '?' + stringified : '';
            !isLoggedIn && dispatch(openSignUpModal());
            history.push(newLocation);
        }
    }, [dispatch, isLoggedIn, location, queryParams, history]);

    return null;
};

export default SignupAction;
